module.exports = __webpack_public_path__ + "static/media/AstraZeneca.e4cd33f2.gif";